import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';

import * as authApi from '@api/auth';

const Register = ({ onSwitchToLogin, onSuccess }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password !== confirm) {
      setError('Passwords do not match');
      return;
    }
    if (password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }
    setLoading(true);
    try {
      const data = await authApi.register(email, password);
      login(data.token, data.email);
      if (onSuccess) onSuccess(data.token, data.email);
    } catch (err) {
      setError(err.status ? err.message : 'Network error');
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        display: 'grid',
        placeItems: 'center',
        width: '100%',
        padding: '32px 24px',
        background: 'transparent',
        boxSizing: 'border-box',  // important
      }}
    >
      <form onSubmit={handleSubmit} style={{ width: '100%', maxWidth: 340 }}>
        <h2 style={{ marginBottom: 8, fontSize: 24, color: 'var(--text-primary)' }}>Create Account</h2>
        <p style={{ marginBottom: 24, color: 'var(--text-secondary)' }}>Sign up to get started</p>

        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
          style={{
            width: '100%',
            padding: '12px 16px',
            marginBottom: 12,
            borderRadius: 8,
            border: '1px solid var(--border)',
            background: 'var(--bg-elevated)',
            color: 'var(--text-primary)',
            fontSize: 14,
            outline: 'none',
            transition: 'border-color 0.15s',
          }}
          onFocus={e => (e.target.style.borderColor = 'var(--accent)')}
          onBlur={e => (e.target.style.borderColor = 'var(--border)')}
        />

        <input
          type="password"
          placeholder="Password (min 6 chars)"
          value={password}
          onChange={e => setPassword(e.target.value)}
          required
          style={{
            width: '100%',
            padding: '12px 16px',
            marginBottom: 12,
            borderRadius: 8,
            border: '1px solid var(--border)',
            background: 'var(--bg-elevated)',
            color: 'var(--text-primary)',
            fontSize: 14,
            outline: 'none',
            transition: 'border-color 0.15s',
          }}
          onFocus={e => (e.target.style.borderColor = 'var(--accent)')}
          onBlur={e => (e.target.style.borderColor = 'var(--border)')}
        />

        <input
          type="password"
          placeholder="Confirm Password"
          value={confirm}
          onChange={e => setConfirm(e.target.value)}
          required
          style={{
            width: '100%',
            padding: '12px 16px',
            marginBottom: 20,
            borderRadius: 8,
            border: '1px solid var(--border)',
            background: 'var(--bg-elevated)',
            color: 'var(--text-primary)',
            fontSize: 14,
            outline: 'none',
            transition: 'border-color 0.15s',
          }}
          onFocus={e => (e.target.style.borderColor = 'var(--accent)')}
          onBlur={e => (e.target.style.borderColor = 'var(--border)')}
        />

        <button
          type="submit"
          disabled={loading}
          style={{
            width: '100%',
            padding: '12px',
            background: 'var(--accent)',
            color: 'var(--text-on-accent)',
            border: 'none',
            borderRadius: 8,
            fontSize: 16,
            fontWeight: 600,
            cursor: loading ? 'default' : 'pointer',
            opacity: loading ? 0.7 : 1,
          }}
        >
          {loading ? 'Creating account...' : 'Register'}
        </button>

        {error && (
          <p style={{ marginTop: 12, color: 'var(--live-red)', fontSize: 14 }}>{error}</p>
        )}

        <p style={{ marginTop: 20, fontSize: 14, textAlign: 'center', color: 'var(--text-secondary)' }}>
          Already have an account?{' '}
          <button
            type="button"
            onClick={onSwitchToLogin}
            style={{
              background: 'none',
              border: 'none',
              color: 'var(--accent)',
              cursor: 'pointer',
              textDecoration: 'underline',
              fontSize: 14,
            }}
          >
            Log in
          </button>
        </p>
      </form>
    </div>
  );
};

export default Register;